<template>

  <div id="app">
    <div class="container">
      <div class="title">
        <img class="title-img" src="../assets/logo/no-word-logo.png">
        <div class="title-font">红山开源证书查询</div>
      </div>

      <div class="not-found">
        <img src="../assets/icon/notfound.svg" class="not-found-img">
        <div class="not-found-title">您查询的证书不存在<br/>请与证书发放人员确认</div>


      </div>
    </div>
  </div>

</template>

<script>
import "../assets/font/font.scss";

export default {
  name: "CertificateQueryNotFound"
}
</script>

<style scoped>


.not-found{
  margin-top: 160px;

}

.not-found-title{
  margin-top: -80px;
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-family: Alibaba;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
}
.container{
  background: linear-gradient(180deg, rgba(150, 160, 247, 0.3082) 0%, rgba(185, 192, 250, 0) 100%);
  height: 100vh;
  padding-left: 4vw;
  padding-right: 4vw;
  padding-top: 3vh;
}

.title{
  margin-left: 8px;
  width: 269px;
  height: 61px;
  display: flex;
  align-items: center;
}

.title-font{
  font-size: 24px;
  font-weight: 900;
  line-height: normal;
  margin: 0 auto;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #3D3D3D;

}
.title-img{
  width: 61px;

}


</style>
